// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adjustFooter[data-v-16dd1e29]{\n  max-width: 778px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
